<script>
import apis from "@/apis";
const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];
export default {
  mounted() {
    this.get_list();
  },
  data() {
    return {
      applications: [],
      fields: [
        { key: "AgencyName", label: "Agency Name" },
        { key: "GazetteReference", label: "Gazette No", sort: true },
        { key: "GazetteDate", label: "From Date", sort: true, formatter: "convertDateFormat" },
        { key: "To_date", label: "To Date", sort: true, formatter: "convertDateFormat" },
        // { key: "Renew", label: "Renew" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },
  methods: {
    convertDateFormat(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      if (dbDateTime.getFullYear() == 1) {
        return null;
      }

      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        months[dbDateTime.getMonth()] +
        "-" +
        dbDateTime.getFullYear();
      return formattedDate;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewApplication(item, index, target) {
      this.$router.push({
        name: "ViewExemptApplication",
        params: { applicationId: item.ExemptionApplicationID }
      });
    },
    Renew(item, index, target) {
      this.$dialog
        .confirm(
          "Do you want to Renew Gazette?",
          { okText: "Renew", cancelText: "Close" }
        )
        .then(function (dialog) {

          this.Renew_gazette();

        })
        .catch(function () { });
    },
    get_list() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadRegistrationDetails(
        userinfo.UserId,
        userinfo.RegistrationType
      );
      promise
        .then(response => {
          this.form = JSON.parse(response.body.FormDetails);





          var payload = {
            // AgencyName: this.form.AgencyName,
            AgencyName: 'M/s. Modern Veer Rays Security Force (India) Pvt. Ltd'

          };
          let promise2 = apis.GetGazette_by_agency_wise(payload);

          promise2
            .then(response => {
              this.applications = response.body;
              this.totalRows = this.guards.length;

              this.isLoading = false;
            })
            .catch(err => {
              this.alertText = err.body;
              this.showDismissibleAlert = true;
              this.variant = "danger";
              this.isLoading = false;
            });

        });
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  }
};
</script>
<!-- ================================================================================================================================================================= -->
<template>
  <b-container>
    <div class="body-wrapper">
      <div class="body-title">
        <b-row>
          <b-col>
            <h5 style="color:#2284ab">Gazette List</h5>
          </b-col>
        </b-row>
      </div>
      <div class="body-content">
        <b-row class="mt-2">
          <b-col md="12">
            <b-row class="mb-2">
              <b-col md="3">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
                  </b-input-group-append>
                </b-input-group>

              </b-col>
              <b-col md="7"></b-col>
              <b-col style="font-size:0.875rem;float:right;"><b>Total Gazette:</b> {{ totalRows }}

              </b-col>
            </b-row>
            <b-table show-empty head-variant="dark" stacked="md" bordered striped :items="applications" :fields="fields"
              :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" style="font-size:12px" @filtered="onFiltered">
              <template slot="actions" slot-scope="row">
                <b-button variant="link" size="sm" @click.stop="viewApplication(row.item, row.index, $event.target)"
                  class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="View Guard Details">
                  <i class="fa fa-eye" style="font-size:16px;color:green"></i>
                </b-button>
              </template>
              <template slot="Renew" slot-scope="row">
                <b-button variant="link" size="sm" @click.stop="Renew(row.item, row.index, $event.target)"
                  class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="Renew Notification">
                  RE-NEW
                </b-button>
              </template>
            </b-table>
            <b-row>
              <b-col md="8" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"
                  size="sm" />
              </b-col>
              <b-col md="4" class="my-1">
                <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
                  <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
                </b-form-group>
              </b-col>
            </b-row>

          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>



// WEBPACK FOOTER //
// src/components/ApplyForExemption/NotificationList.vue